import { cableCarStopIds } from "@/lib/transitData";

export default function checkStopType(sms) {
  if (sms) {
    if (isNaN(sms)) {
      if (cableCarStopIds.includes(sms)) {
        return "cable_car";
      } else {
        return "train";
      }
    } else {
      if (sms >= 9995) {
        return "ferry";
      } else {
        return "bus";
      }
    }
  }
  return undefined;
}
